import React, { useEffect } from 'react';
import useSeasonApi from 'admin/hooks/useSeasonApi';
import styled from 'styled-components';

export const SeasonBanner: React.FC = () => {
  const { currentSeasonInDropDown, serviceDataList, loading } = useSeasonApi();
  useEffect(() => {
    currentSeasonInDropDown();
  }, []);
  return (
    <BannerContainer>
      <BannerLabel>Current Season</BannerLabel>
      <SeasonName>
        {loading ? 'Loading...' : serviceDataList?.liveSeason?.name}
      </SeasonName>
    </BannerContainer>
  );
};

const BannerContainer = styled.section`
  border-radius: 16px;
  background-color: #edf0ff;
  display: flex;
  min-height: 51px;
  width: 100%;
  padding: 17px 24px;
  align-items: center;
  gap: 40px 100px;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.14px;
  line-height: 1.2;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 17px 20px;
  }
`;

const BannerLabel = styled.h2`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  gap: 32px;
  font-size: 14px;
  font-weight: bold;
`;

const SeasonName = styled.div`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  gap: 10px;
`;
